



























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Location } from 'vue-router'
import type { Atualizacao } from '@/shareds/novidades/modelo'
import {
	contagem,
	itensRestantes,
	mosaico,
	parteDoMes,
	rotuloDoBotaoDeLeitura,
} from '@/shareds/novidades/modelo'

const ITENS_NA_CAPA = 6

@Component
export default class CapaDaAtualizacao extends Vue {
	@Prop({ type: Object, required: true }) atualizacao!: Atualizacao
	@Prop({ type: Boolean, default: false }) nova!: boolean

	get primeiros() {
		return this.atualizacao.itens.slice(0, ITENS_NA_CAPA)
	}

	get contagem() {
		return contagem(this.atualizacao)
	}

	get parte() {
		return parteDoMes(this.atualizacao)
	}

	get restantes() {
		return itensRestantes(this.atualizacao, this.primeiros.length)
	}

	get rotuloDoBotao() {
		return rotuloDoBotaoDeLeitura(this.atualizacao)
	}

	get imagens() {
		return mosaico(this.atualizacao)
	}

	rotaDeLeitura(item?: number): Location {
		return {
			name: 'Novidade',
			params: { id: this.atualizacao.id },
			query: item ? { item: String(item) } : {},
		}
	}
}
